// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__frozl","fadein":"Modal_fadein__971gy","modalContent":"Modal_modalContent__H1CMl"};